export default "__VITE_ASSET__ffeDxVY9__"